import { useAuth } from '@features/auth/context/AuthContext';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useCalendarStore } from '../store/useCalendarStore';

/**
 * Component that initializes the calendar data once when the app loads
 * Only fetches data if the user is authenticated and on a protected route
 */
export const CalendarInitializer: React.FC = () => {
  const { fetchCalendarData, initialized } = useCalendarStore();
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const initializationAttempted = useRef(false);

  useEffect(() => {
    // Only fetch calendar data if:
    // 1. User is authenticated
    // 2. Store is not already initialized
    // 3. We haven't attempted initialization yet (to prevent infinite loops)
    // 4. User is on a protected route (not public or onboarding)
    const isProtectedRoute =
      !location.pathname.startsWith('/signin') &&
      !location.pathname.startsWith('/signup') &&
      !location.pathname.startsWith('/reset-password') &&
      !location.pathname.startsWith('/onboarding');

    if (isAuthenticated && !initialized && !initializationAttempted.current && isProtectedRoute) {
      initializationAttempted.current = true;
      fetchCalendarData(false);
    }
  }, [isAuthenticated, initialized, fetchCalendarData, location.pathname]);

  // This component doesn't render anything
  return null;
};

export default CalendarInitializer;
